import type { FC } from "react";
import { IconButton, Button } from "@similarweb/ui-components";

type EnrichmentCardButtonProps = {
    type: "primary" | "trial";
    text: string;
    onClick: () => void;
};
const EnrichmentCardButton: FC<EnrichmentCardButtonProps> = ({ type, text, onClick }) => {
    if (type === "trial") {
        return (
            <IconButton
                type="trial"
                onClick={onClick}
                iconName="sparkles"
            >
                {text}
            </IconButton>
        );
    }

    return (
        <Button
            type="primary"
            onClick={onClick}
        >
            {text}
        </Button>
    );
};

export default EnrichmentCardButton;
